import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useGroupUserInvitationsState,
  useGroupUserInvitationsActions
} from './GroupUserInvitationsContext';

import {
  closeGroupUserInvitation,
  closeAndResendGroupUserInvitation,
} from './restApi';

import styles from './GroupUserInvitations.module.scss';

const formatExpirationDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

const isExpired = (dateString) => {
  if (!dateString) return false;
  return new Date(dateString) < new Date();
};

const GroupUserInvitationsTable = () => {
  const groupUserInvitationsState = useGroupUserInvitationsState();
  const { onResponse, onError } = useGroupUserInvitationsActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const groupId = groupUserInvitationsState?.groupId;

  return groupUserInvitationsState?.openUserInvitations?.length ? (
    <table className={styles.table}>
      <thead>
        <tr className={styles.tr}>
          <th className={styles.th}>Name</th>
          <th className={styles.th}>Email</th>
          <th className={styles.th}>Expires At</th>
        </tr>
      </thead>
      <tbody>
        {groupUserInvitationsState?.openUserInvitations?.map(invitation => {
          return (
            <tr key={invitation.id} className={styles.tr}>
              <td className={styles.td}>{invitation.firstName} {invitation.lastName}</td>
              <td className={styles.td}>{invitation.email}</td>
              <td className={styles.td} style={isExpired(invitation.expiresAt) ? { color: 'var(--color-danger, red)' } : {}}>
                {formatExpirationDate(invitation.expiresAt)}
              </td>
              <td className={styles.td}>
                {isExpired(invitation.expiresAt) ? (
                  <Button
                    variant="primary"
                    onClick={() => {
                      closeAndResendGroupUserInvitation({
                        groupId,
                        invitation,
                        onResponse,
                        onError,
                        authenticityToken,
                      });
                    }}
                  >
                    Close and Resend Invitation
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    onClick={() => {
                      closeGroupUserInvitation({
                        groupId,
                        invitation,
                        onResponse,
                        onError,
                        body: {
                          closeOpenUserInvitationForm: {
                            groupId: groupId,
                            openUserInvitationId: invitation.id,
                          },
                          authenticityToken: authenticityToken,
                        },
                      });
                    }}
                  >
                    Close Invitation
                  </Button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <p className={styles.noContentMessage}>No open user invitations.</p>
  );
};

export default GroupUserInvitationsTable;
